/**
 * Provides a simple interface which displays the attributes of a given `Point`.
 * @module app/views/map/MapPointView
 */
import Backbone from "backbone";
import _ from "underscore";
export default Backbone.View.extend({
  className: "map-point-wrapper",

  template: _.template(
    '<div class="map-point">Latitude:&nbsp;<span class="lat-value"><%= (point[1] || 0).toFixed(6) %></span><br/>Longitude:&nbsp;<span class="long-value"><%= (point[0] || 0).toFixed(6) %></span></div>'
  ),

  /**
   * Initializes the view.
   * @param  {object} options The options hash.
   * @param {Point} options.point The point to display.
   */
  initialize: function (options) {
    this.options = options;
  },

  render: function () {
    this.$el.html(this.template(this.options));
  },
});



//////////////////
// WEBPACK FOOTER
// ./public/js/app/views/map/MapPointView.js
// module id = 904
// module chunks = 1